<template>
  <div>
    <md-table v-model="feedbacksList" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        {{ item.name }}
        <md-table-cell md-label="Name">{{ item.fullname }}</md-table-cell>
        <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
        <md-table-cell md-label="Subject">{{ item.subject }}</md-table-cell>
        <md-table-cell md-label="Body">{{ item.body }}</md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
  export default {
    name: 'simple-table',
    props: {
      tableHeaderColor: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        feedbacksList: []
      }
    },
    beforeMount: function () {
      this.$store.dispatch('GetFeedBackList').then((response) => {
        console.log(response)
        this.feedbacksList = response.data.data;
        console.log(this.feedbacksList)

      });
    },

  }
</script>
<style>

</style>
